import React, { Component, PropTypes } from 'react'
import withCdnUrl from './withCdnUrl'

export class QuadColumn extends Component {
  render() {
    return (
      <section className="section--lgrey">
        <div className="container">
          <div className="section__head--noPara">
            <h2>Our Core Values</h2>
          </div>
          <div className="section__body">
            <div className="row">
              <div className="column--fourth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-player.gif`} />
                  <div className="meta">
                    <h4>Player Experience First</h4>
                    <p>
                      We’re building this for the next generation of players and athletes; their experience is
                      our top priority.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--fourth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-teamwork.gif`} />
                  <div className="meta">
                    <h4>Teamwork</h4>
                    <p>
                      You don’t get there alone. CEOs and legends all give this same advice, so we take
                      teamwork seriously.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--fourth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-all_in.gif`} />
                  <div className="meta">
                    <h4>All in</h4>
                    <p>
                      If you’re comfortable on the fence, you’re not one of us. Like our players and coaches,
                      we’re 100% all in.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--fourth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-impossible.gif`} />
                  <div className="meta">
                    <h4>
                      <span className="strikeout">Impossible</span> Possible
                    </h4>
                    <p>
                      We dare to expand the definition of what’s possible every day; impossible is our
                      favorite kind of possible.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default withCdnUrl(QuadColumn)



// WEBPACK FOOTER //
// ./src/common/ui/components/quadColumn.js